import AOClpCarouselSlider from '@atomic/organisms/clp/carousel-slider/scripts';

export default function AOClpCardsSlider() {
  const initiate = () => {
    const $aoClpCarouselSlider = AOClpCarouselSlider();
    $aoClpCarouselSlider.initiate();
  };

  return { initiate };
}
